module.exports = __webpack_public_path__ + "img/star_3_5.cad99283.png";